import * as api from '../../apis/sales';
import { apiCall } from '~/lib/redux/api';
import { EntityActions } from '~/apps/shared/actions/consts';
import {SaleActions, SalesTotalsActions} from './consts';
import {SaleNormalizer} from './normalize';
import {
  saleGetListParamsURL,
  salePostParamsBody,
  salePostPayCheckoutParamsBody,
  salePostPayCodeParamsBody,
  salePostPayOtherParamsBody,
} from '~/apps/pos/models';


export function getSaleList(saleListParams: saleGetListParamsURL = {}) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, SaleActions.LOAD_LIST_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: [SaleNormalizer],
    fn: () => api.getSaleList(saleListParams),
  })
}

export function getSalesTotals(saleListParams: saleGetListParamsURL = {}) {
  return apiCall({
    actions: [
      SalesTotalsActions.LOAD_REQUEST,
      SalesTotalsActions.LOAD_SUCCESS,
      SalesTotalsActions.LOAD_ERROR,
    ],
    fn: () => api.getSalesTotals(saleListParams),
  })
}

export function getSaleById(saleId: string) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: SaleNormalizer,
    fn: () => api.getSaleById(saleId),
  })
}

export function createSale(dataSale: salePostParamsBody) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.createSale(dataSale),
  })
}

export function updateSale(saleId: string, dataSale: salePostParamsBody) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.updateSale(saleId, dataSale),
  })
}

export function deleteSale(saleId: string) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.deleteSale(saleId),
  })
}

export function paySaleByCode(saleId: string, data: salePostPayCodeParamsBody) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.paySaleByCode(saleId, data),
  })
}

export function paySaleByCheckout(saleId: string, data: salePostPayCheckoutParamsBody) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.paySaleByCheckout(saleId, data),
  })
}

export function paySaleByOther(saleId: string, data: salePostPayOtherParamsBody) {
  return apiCall({
    actions: [
      SaleActions.LOAD_REQUEST,
      [SaleActions.LOAD_SUCCESS],
      SaleActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.paySaleByOther(saleId, data),
  })
}

export function setSaleCurrentPage(page: number = 0) {
  return {
    type: SaleActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
